import React from 'react';
import { useQuotesList } from '../../hooks/useQuotesList';
import { useClosedOrders } from '../../hooks/useClosedOrders';
import { DashboardHeader } from '../../components/user/DashboardHeader';
import { QuotesList } from '../../components/user/QuotesList';
import { ClosedOrdersList } from '../../components/user/ClosedOrdersList';

export const QuotesListPage: React.FC = () => {
  const quotes = useQuotesList();
  const closedOrders = useClosedOrders();

  return (
    <div className="space-y-6">
      <DashboardHeader userName={quotes.user?.name} quotes={quotes.quotes} />
      <QuotesList {...quotes} />
      <ClosedOrdersList {...closedOrders} />
    </div>
  );
};
